import { Controller } from 'stimulus';
const TomSelect = require('../lib/tom_select');

export default class extends Controller {
  connect() {
    if (this.tomSelect) return;

    const options = {
      plugins: ['clear_button'],
      placeholder: this.element.dataset.placeholder || '',
      searchConjunction: 'and',
    };

    if (this.element.multiple) {
      options.plugins.push('remove_button');
      // Clear the typed filter text after each pick so the next item can be
      // searched immediately instead of the list staying filtered.
      options.onItemAdd = function () {
        this.setTextboxValue('');
        this.refreshOptions(false);
      };
    }

    if (this.element.dataset.dynamic === 'true') {
      options.create = true;
    }

    this.tomSelect = new TomSelect(this.element, options);
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
      this.tomSelect = null;
    }
  }
}
